(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /*NOTE: Currently not used. If it's going to be used, jquery-ui needs to be updated to include effect()
   Would be implemented like: ws-event-effect="some-item-save-event | highlight | duration:slow | select:td" */
  directive('wsEventEffect', ['$timeout', function ($timeout) {
    return function wsEventEffectLink(scope, element, attrs) {
      var attrValues = attrs.wsEventEffect.split(/\s*\|\s*/),
        event = attrValues[0],
        effect = attrValues[1],
        modifiers = attrValues.slice(2),
        options = {
          "effect": effect
        };
      angular.forEach(modifiers, function (modifier) {
        var nameVal = modifier.split(":"),
          name = nameVal[0],
          val = nameVal.slice(1).join(':');

        //If number, parse and convert it
        if (!isNaN(Number(val))) {
          val = Number(val);
        }
        options[name] = val;
      });
      scope.$on(event, function () {
        $timeout(function () {
          var target = options.select ? element.find(options.select) : element;
          target.effect(options);
        }, 0);
      });
    };
  }]);
})();
